module.exports = __webpack_public_path__ + "static/media/visa-icon-32x20.6e1ba589.svg";